import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';
import { HandleError, HttpErrorHandler } from 'mds-ui/app/shared/service/http-error-handler.service';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do'; // debug
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/Rx'; // use this line if you want to be lazy, otherwise: 
import { Observable } from 'rxjs/Rx';
import { environment } from 'mds-ui/environments/environment';
import { catchError } from 'rxjs/operators';
 

@Injectable()
export class DocumentService {
    public filesToUpload: Array<File>;
    filenames: string[];
    removedFileNames: string[];
    docFlag:boolean;
    private handleError: HandleError;
    dtformat = new DateTimeFormatPipe("en-US");
    constructor(private _http: HttpClient, private httpErrorHandler: HttpErrorHandler,
      ) { 
            this.handleError = httpErrorHandler.createHandleError('DocumentService');
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    };
    
    getDocument(filePath: string, projectName: string, userName: string)  {
        return this._http.get<any>(
          environment.getDocumentURL +"?filePath=" +filePath + "&projectName=" + projectName + "&userName=" + userName +
           "&dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(catchError(this.handleError('getDocument', [])));
      }
      postemailDetails(filePath: string, projectName: string, userName: string,emailId:string): Observable<any> {
        return this._http.post<any>(environment.postemailDetailsURL+"?filePath=" +filePath + "&projectName=" 
        + projectName + "&userName=" + userName +"&emailId="+emailId, this.httpOptions)
       
        .pipe(catchError(this.handleError('postemailDetails()', [])));
    }

    

}